import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2684d448")

_pushScopeId("data-v-2684d448")
const _hoisted_1 = { class: "risk-analysis" }
const _hoisted_2 = { class: "risk-analysis-wrap" }
const _hoisted_3 = { class: "risk-analysis-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("下一步")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_sceneDesignMainHeader = _resolveComponent("sceneDesignMainHeader")
  const _component_a_button = _resolveComponent("a-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_sceneDesignMainHeader, {
        class: "mb24",
        headerText: _ctx.props.headerText
      }, null, 8, ["headerText"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          class: "mr18",
          type: "primary"
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "next",
          ghost: "",
          onClick: _ctx.nextStep
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
})